
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'

@Component({
  components: {
    NewSwiper,
    LazyImg
  }
})
export default class Tabs extends Vue {
  @Prop({ default: 0 }) active: number
  @Prop() tabList: unknown[]

  isLastSlideInView: boolean = false
  isFirstSlideInView: boolean = true
  inView: number = 0

  @Ref()
  swiper: {
    emblaApi: any
    dotScrollTo: (index: number) => void
  }

  @Emit('change')
  changeTab(index: number) {
    return index
  }

  // 直接拉到头部
  handlePrev() {
    if (!this.swiper) return
    this.swiper.dotScrollTo(0)
    this.inView = 0
  }

  // 直接拉到尾部
  handleNext() {
    if (!this.swiper) return
    this.swiper.dotScrollTo(this.tabList.length - 1)
    this.inView = this.tabList.length - 1
  }

  // 滚动条滚动事件
  handleChange(idx: number) {
    // 滚动条的滚动动画是0.15s
    setTimeout(() => {
      const firstSlide = 0
      const lastSlide = this.swiper.emblaApi.slideNodes().length - 1
      this.isFirstSlideInView = this.inView === firstSlide
      this.isLastSlideInView = this.inView === lastSlide
    }, 200)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
